//南山调试逻辑，后面需要做成标准功能
//
export function tryPointDiagnosis(myInfo) {
  let debugAuthorize = myInfo && myInfo.debugAuthorize;

  //console.log('debugAuthorize', debugAuthorize);

  if (debugAuthorize) {
    return true;
  }

  return false;
}

export function loadDiagnosisScript() {
  setTimeout(function () {
    var ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    ga.src = 'https://helioscloud-uat-static.oss-cn-shanghai.aliyuncs.com/luqiang-dev/eruda.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);
  }, 1000);
  setTimeout(function () {
    var eruda = eruda || window.eruda;
    eruda && eruda.init();
  }, 2000);
}
